import { Button } from '@shared/components/shadcn';
import { ChevronLeft } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { useMultistepForm } from '../../../../form-controls/MultistepForm/hooks/useMultistepForm';

function BackButton() {
  const { isFirstStep, goToPreviousStep } = useMultistepForm();
  const t = useTranslations('common');

  // Don't show back button on first step
  if (isFirstStep) return null;

  return (
    <div className="mb-5 hidden md:block">
      <Button
        variant="ghost"
        onClick={goToPreviousStep}
        className="md:flex items-center justify-center w-8 h-8 rounded-full bg-button-background-inverse p-0 hover:bg-button-background-inverse-hover"
        type="button"
        aria-label={t('back')}
        data-track-name="Back"
        data-testid="back-button"
      >
        <ChevronLeft size="small" />
      </Button>
    </div>
  );
}

export { BackButton };
